import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 2.71741L2 5.92575V21.5001L7.5 19.2328V2.71741Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.5 18.9097L12 20.3861V16.25C12 14.2052 12.9819 12.3898 14.5 11.2495V5.09051L9.5 2.1377V18.9097Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2.50012V11.2495C20.9554 10.4649 19.657 10 18.25 10C17.6425 10 17.0553 10.0867 16.5 10.2483V4.76744L22 2.50012Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 16.25C23 17.1992 22.7216 18.0834 22.2419 18.8254L23.9142 20.5017L22.4983 21.9142L20.8282 20.2401C20.0857 20.7209 19.2004 21 18.25 21C15.6266 21 13.5 18.8734 13.5 16.25C13.5 13.6266 15.6266 11.5 18.25 11.5C20.8734 11.5 23 13.6266 23 16.25ZM21 16.25C21 14.7312 19.7688 13.5 18.25 13.5C16.7312 13.5 15.5 14.7312 15.5 16.25C15.5 17.7688 16.7312 19 18.25 19C19.0062 19 19.691 18.6948 20.1882 18.2009L20.1961 18.1929C20.6929 17.6954 21 17.0086 21 16.25Z"}}]};

const MapSearchFilled = Vue.extend<IconProps>({
  name: 'MapSearchFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-search-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapSearchFilled;
